// extracted by mini-css-extract-plugin
module.exports = {"dialogReservationJtails":"DialogScheduleItem_dialogReservationJtails_3S7Of"};